import Footer from '@app/components/Footer'
import Navbar from '@app/components/Navbar'
import { ReactMarkdown } from 'react-markdown/lib/react-markdown'
import { useIntl } from 'react-intl'
import remarkGfm from 'remark-gfm'
import S from './styles'

const Cookies = () => {
  const { messages } = useIntl()

  return (
    <>
      <Navbar />
      <S.Main>
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{messages['static.page.cookie_policy'] as string}</ReactMarkdown>
      </S.Main>
      <Footer />
    </>
  )
}

export default Cookies
